import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=1ac36c66&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=1ac36c66&scoped=true&lang=css&"
import style1 from "./contact.vue?vue&type=style&index=1&id=1ac36c66&lang=scss&scoped=true&"
import style2 from "./contact.vue?vue&type=style&index=2&id=1ac36c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac36c66",
  null
  
)

export default component.exports